"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormalCharge = void 0;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the formal charge of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns Computed Data
 */
function getFormalCharge(data) {
    const formalCharge = (0, getNumberProperties_1.getNumberProperties)(data, 'Formal Charge');
    return formalCharge;
}
exports.getFormalCharge = getFormalCharge;
//# sourceMappingURL=getFormalCharge.js.map